import BarChartRAAeachRA from './components/BarChartRAAeachRA';
import BarChartRAAeachLand from './components/BarChartRAAeachLand';
import RABarChart1 from './components/RABarChart1';
import PieChartRA from './components/PieChartRA';
import PieChartRAA from './components/PieChartRAA';
import {
    Card,
    Grid,
} from '@mui/material';

const Page2 = () => {
    return (
        <>
        <Grid sx={{ p: 5 }}><text>
                <h2>Statistiken RA/RAA</h2>

                <p>                  Hier finden Sie die Zahlen zur Verteilung der Rechtsanwält:innen und Rechtsanwaltsanwärter:innen auf die bzw in den Bundesländer(n). Die Statistiken basieren auf den vom ÖRAK erhobenen Zahlen.

                </p>



            </text></Grid>
                    
            <Card sx={{ mt: 5 }}>
                <Grid sx={{ p: 5 }}>
                    <Grid>
                        <div className="container">
                            <BarChartRAAeachRA />
                        </div>
                    </Grid>
                </Grid>
            </Card>
            <Card sx={{ mt: 5 }}>
                <Grid sx={{ p: 5 }}>
                    <Grid>
                        <div className="container">
                            <BarChartRAAeachLand />
                        </div>
                    </Grid>
                </Grid>
            </Card>
            <Card sx={{ mt: 5 }}>
                <Grid sx={{ p: 5 }}>
                    <Grid>
                        <div className="container">
                            <RABarChart1 />
                        </div>
                    </Grid>
                </Grid>
            </Card>
            <Card sx={{ mt: 5 }}>
                <Grid sx={{ p: 5 }}>
                    <Grid>
                        <div className="container">
                            <PieChartRA />
                        </div>
                    </Grid>
                </Grid>
            </Card>
            <Card sx={{ mt: 5 }}>
                <Grid sx={{ p: 5 }}>
                    <Grid>
                        <div className="container">
                            <PieChartRAA />
                        </div>
                    </Grid>
                </Grid>
            </Card>
        </>
    )
};

export default Page2;
